import { cn } from '@/shared/utils/formatting';

export type VideoPillState = 'live' | 'draft' | 'scheduled';

const PILL: Record<VideoPillState, { label: string; className: string }> = {
  live: { label: 'Live', className: 'bg-green-500/12 text-green-300' },
  scheduled: { label: 'Scheduled', className: 'bg-amber-500/12 text-amber-200' },
  draft: { label: 'Draft', className: 'bg-white/8 text-text-tertiary' },
};

export function VideoStatusPill({ state }: { state: VideoPillState }) {
  const { label, className } = PILL[state];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium',
        className
      )}
    >
      {label}
    </span>
  );
}

export function deriveVideoPillState(video: {
  published?: boolean;
  published_at?: string | null;
  publish_schedule?: { scheduled_at?: string | null } | null;
}): VideoPillState {
  if (video.published) return 'live';
  if (video.publish_schedule?.scheduled_at) return 'scheduled';
  return 'draft';
}
